import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { filtrationSuccessAction } from '../filters/actions';
import type { IHotelsState } from './types';
import type { FiltrationSuccess } from '../filters/types';

const initialState: IHotelsState = {
  hotels: [],
  currentPage: 0,
  hotelsCount: 20,
  currentVisibleHotels: [],
  pageLimit: 15,
  liveSearchAllowed: undefined,
  awaitingPagination: false,
  filtered_hotels: [],
  fallbackSearch: false,
  nearestDepartures: null,
  nearestDates: null,
};

const getState = (state) =>
  typeof state.toJS === 'function' ? state.toJS() : state;

const hotels = createSlice({
  name: 'hotels',
  initialState,
  reducers: {
    showMore: (state) => {
      const { currentPage } = getState(state);
      return {
        ...getState(state),
        awaitingPagination: true,
        currentPage: currentPage + 1,
      };
    },
    paginationSuccess: (
      state,
      action: PayloadAction<{ resultHotels: IHotelsState['hotels'] }>,
    ) => {
      const { resultHotels } = action.payload;
      return {
        ...getState(state),
        hotels: [...resultHotels],
        awaitingPagination: false,
      };
    },
    setCurrentVisibleHotels: (state, action: PayloadAction<number[]>) => ({
      ...getState(state),
      currentVisibleHotels: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(
      filtrationSuccessAction,
      (state, action: PayloadAction<FiltrationSuccess>) => {
        const {
          hotels: newHotels,
          hotelsCount,
          filtered_hotels,
        } = action.payload;
        return {
          ...getState(state),
          hotels: newHotels,
          currentPage: 0,
          hotelsCount,
          awaitingPagination: false,
          filtered_hotels,
        };
      },
    );
  },
});

export const { showMore, paginationSuccess, setCurrentVisibleHotels } =
  hotels.actions;

export const { name } = hotels;
export { initialState };

export default hotels.reducer;
